"use strict";
const XMLHttpRequestEventTargetImpl = require("./XMLHttpRequestEventTarget-impl").implementation;

exports.implementation = class XMLHttpRequestUploadImpl extends XMLHttpRequestEventTargetImpl {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/xhr/XMLHttpRequestUpload-impl.js
// module id = NPiH
// module chunks = 0